import { createSelector } from 'reselect'
import { getAuthenticityToken } from 'Shared/helpers'
import FetcherFactory from 'Shared/FetcherFactory'

const reducerName = 'POTENTIAL_LEAGUES_FOR_CLONING'

const factory = new FetcherFactory(
  reducerName,
  ({params, state, dispatch, factory}) => {
    const queryString = new URLSearchParams(params).toString()

    return fetch(`${state.baseURL}?${queryString}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': getAuthenticityToken(),
        'Content-Type': 'application/json',
      },
    }).then(response => {
      // Pre-process the response
      return response.json().then(data => {

        const setPaginationAction = factory.getSetPaginationAction()
        dispatch(setPaginationAction(data?.pagination))

        return ({
          data: data,
          status: response.status,
        })
      })
    })
  },
)

const selectPotentialLeaguesForCloning = createSelector(
  [ state => state[factory.name]?.data?.leagues ],
  (potentialLeaguesForCloning) => potentialLeaguesForCloning,
)

const selectPotentialLeaguesForCloningPagination = createSelector(
  [ state => state[factory.name]?.pagination ],
  (potentialLeaguesForCloningPagination) => potentialLeaguesForCloningPagination,
)

const selectPotentialLeaguesForCloningLoading = createSelector(
  [ state => state[factory.name]?.loading ],
  (potentialLeaguesForCloningLoading) => potentialLeaguesForCloningLoading
)

const PotentialLeaguesForCloningReducer = factory.getReducer()
const fetchPotentialLeaguesForCloningMergedParams = factory.getFetchAction({useMergedParams: true})
const setPagePotentialLeaguesForCloning = factory.getSetPageAction()
const namedReducer = {[reducerName]: PotentialLeaguesForCloningReducer}

const getInitialState = ({leagues, pagination, searchLeaguesURL}) => {
  return {
    data: {
      leagues: leagues,
    },
    pagination: pagination,
    baseURL: searchLeaguesURL,
  }
}

export {
  getInitialState,
  namedReducer,
  factory as PotentialLeaguesForCloningFactory,
  fetchPotentialLeaguesForCloningMergedParams,
  setPagePotentialLeaguesForCloning,
  selectPotentialLeaguesForCloning,
  selectPotentialLeaguesForCloningLoading,
  selectPotentialLeaguesForCloningPagination,
}
